import { ApolloLink } from '@apollo/client/core';
import { HttpHeaders } from '@angular/common/http';
import { readStoredToken } from '../auth/auth-token';

const authLink = new ApolloLink((operation, forward) => {
  const token = readStoredToken();

  operation.setContext({
    headers: new HttpHeaders({
      Authorization: token ? `Bearer ${token}` : '',
    }),
  });

  return forward(operation);
});

export default authLink;
